var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6.00008C7.03518 6.00008 7.33366 6.29856 7.33366 6.66675V11.0001C7.33366 11.3683 7.03518 11.6667 6.66699 11.6667C6.2988 11.6667 6.00033 11.3683 6.00033 11.0001V6.66675C6.00033 6.29856 6.2988 6.00008 6.66699 6.00008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 6.66675C10.0003 6.29856 9.70185 6.00008 9.33366 6.00008C8.96547 6.00008 8.66699 6.29856 8.66699 6.66675V11.0001C8.66699 11.3683 8.96547 11.6667 9.33366 11.6667C9.70185 11.6667 10.0003 11.3683 10.0003 11.0001V6.66675Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42999 0.666748C6.18653 0.666748 5.96242 0.799467 5.8454 1.01296L4.93884 2.66675H1.33366C0.965469 2.66675 0.666992 2.96522 0.666992 3.33341C0.666992 3.7016 0.965469 4.00008 1.33366 4.00008H2.33366V14.6667C2.33366 15.0349 2.63214 15.3334 3.00033 15.3334H13.0003C13.3685 15.3334 13.667 15.0349 13.667 14.6667V4.00008H14.667C15.0352 4.00008 15.3337 3.7016 15.3337 3.33341C15.3337 2.96522 15.0352 2.66675 14.667 2.66675H11.0656L10.18 1.01795C10.0638 0.801673 9.83819 0.666748 9.59269 0.666748H6.42999ZM9.55213 2.66675L9.19404 2.00008H6.82481L6.45936 2.66675H9.55213ZM3.66699 4.00008V14.0001H12.3337V4.00008H3.66699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e108ff092f42f53c3ddbe3ce8fa5fcdf.svg";
export { ForwardRef as ReactComponent };